import { createReducer } from 'src/utils/createReducer';
import { Actions } from './constants';

export const initialState = {
  isLoading: false,
  agency: null,
  agent: null,
  originalAgent: null,
  selectedAgent: null,
  showRenewalsBanner: false,
};

export const Reducer = createReducer(initialState, {
  [Actions.RESET]: () => {
    return initialState;
  },
  [Actions.SET_LOADING]: (store, isLoading) => {
    return { ...store, isLoading };
  },
  [Actions.SET_CURRENT_AGENT]: (store, agent) => {
    return { ...store, agent };
  },
  [Actions.SET_ORIGINAL_AGENT]: (store, originalAgent) => {
    return { ...store, originalAgent };
  },
  [Actions.SET_AGENCY]: (store, agency) => {
    return { ...store, agency };
  },
  [Actions.SET_AGENTS]: (store, agents) => {
    return { ...store, agency: { ...store.agency, ...agents } };
  },
  [Actions.SHOW_RENEWALS_BANNER]: store => {
    return { ...store, showRenewalsBanner: true };
  },
});
